<div [dir]="this.app.getUserDire()">
    <div class="d-flex justify-content-between p-2">
        <div></div>
        <p class="interP m-0">{{ 'social.reportPost' | translate }}</p>
        <mat-icon (click)="cancel()" class="xIcon material-symbols-outlined pointer">cancel</mat-icon>
    </div>
    
    <hr>
    
    <div class="p-3">
    
        <p class="whyReportP">{{ 'social.whyReportThisPost' | translate }}</p>
    
        <p class="yourReportP">{{ 'social.yourReportIsAn' | translate }}</p>
    
        <!-- check boxes -->
        <div class="px-3">
    
            <section class="example-section">
                <div *ngFor="let item of ObjFiltered;let i = index">
                    <p class="centerXY px-2 m-0"><span>{{ app?.languageCode == 'en'
                            ?item?.name:item.nameAr}}</span><mat-checkbox [value]="item?.id" [checked]="selected == item.id"
                            (change)="onChangeSelection($event,item)"></mat-checkbox></p>
                    <hr>
                </div>
            </section>
    
        </div>
        <!-- check boxes -->
    
        <div class="mt-4 d-flex justify-content-center">
            <button (click)="submitReport()" class="btn bgMain w-70">{{ 'social.report' | translate }}</button>
        </div>
    
    </div>
</div>